import React, { Component } from "react";
import IndustryDialog from "../IndustryDialog";
// client profile
import ClientProfile from "../ClientProfile";

import { isEmpty } from "lodash";
import { buttonBlueColor, toCapitalize } from "../../../utils/utility";
// css
import "./business-units.css";

const styles = {
  tableHeaderStyle: {
    border: "none",
    background: "#F5F5F5",
    fontSize: "16px",
  },
  arrowStyle: {
    position: "absolute",
    top: "10px",
  },
  tableHeaderColumn: {
    height: "55px",
    color: "#000",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "16px",
    paddingLeft: "20px",
    paddingRight: "20px",
  },
  tableTd: {
    paddingLeft: "20px",
    paddingRight: "20px",
    height: "55px",
    fontSize: "16px",
    borderBottom: "solid 1px #EBE8EF",
  },
  tableHeaderSortedColumn: {
    height: "55px",
    color: "#000",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "16px",
    backgroundColor: "#E3E3E3",
    paddingLeft: "20px",
    paddingRight: "20px",
    backgroundClip: "padding-box",
  },
  tableRowColumn: {
    position: "relative",
  },
  settingStyle: {
    position: "absolute",
    right: "6em",
    top: "0.9em",
    cursor: "pointer",
  },
};

class BusinessUnits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      showClientProfile: false,
    };
  }
  componentDidMount() {
    this.props.getClientProfile(this.props.match.params.id); // when user click back button from business detail page get the client detail.
    this.props.getTierOptions();
    this.props.getClientBusiness(this.props.match.params.id);
    this.props.get_client_options();
    this.props.getIndustryOptions();
    this.props.getTeamMember(this.props.match.params.id); // get business assign to data for ClientProfile
    this.props.getBusinessUnitOptions(); //get business units options for industry dialog component
  }
  handleOpenDialog() {
    this.setState({
      open: true,
    });
  }
  handleCloseDialog() {
    this.setState({
      open: false,
    });
  }
  handleSendInvite() {}
  handleInviteAnotherClient() {
    this.setState({
      open: true,
    });
  }
  handleCreateClientProfile() {
    this.setState({
      showClientProfile: true,
    });
  }
  clientProfileCancel() {
    this.setState({
      showClientProfile: false,
    });

    this.props.getClientBusiness(this.props.match.params.id);
    this.props.getBusinessUnitOptions(); // get business unit options
  }

  render() {
    return (
      <div className="business-units">
        {!this.state.showClientProfile ? (
          <div className="business">
            <h1>
              {this.props.edit_client_profile.name !== undefined &&
                toCapitalize(this.props.edit_client_profile.name)}{" "}
              Business Units
            </h1>
            <table style={{ width: "100%" }}>
              <thead style={styles.tableHeaderStyle}>
                <tr>
                  {[
                    { name: "Name", value: "name" },
                    { name: "Location", value: "location" },
                    { name: "Status", value: "status" },
                    { name: "Subscription Tier", value: "tier" },
                  ].map((item, index) => {
                    if (index === 0) {
                      return (
                        <th
                          style={{ ...styles.tableHeaderColumn, width: "30%" }}
                          key={index}
                        >
                          {item.name}
                        </th>
                      );
                    } else if (index === 1) {
                      return (
                        <th
                          style={{ ...styles.tableHeaderColumn, width: "25%" }}
                          key={index}
                        >
                          {item.name}
                        </th>
                      );
                    } else if (index === 2) {
                      return (
                        <th
                          style={{ ...styles.tableHeaderColumn, width: "23%" }}
                          key={index}
                        >
                          {item.name}
                        </th>
                      );
                    } else {
                      return (
                        <th style={{ ...styles.tableHeaderColumn }} key={index}>
                          {item.name}
                        </th>
                      );
                    }
                  })}
                </tr>
              </thead>
              <tbody>
                {this.props.business_units_list.map(item => (
                  <tr key={item.id}>
                    <td style={styles.tableTd}>
                      <a
                        href={`/clients/edit/Business-Units/detail/${
                          this.props.match.params.id
                        }/${encodeURIComponent(item.name)}/${item.id}`}
                      >
                        {item.name}
                      </a>
                    </td>
                    <td style={styles.tableTd}>
                      {item.city.length > 0 ? `${item.city},` : ""} {item.state}
                    </td>
                    <td style={styles.tableTd}>{item.status}</td>
                    <td style={styles.tableTd}>
                      {item.subscription && item.subscription.name}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="btns">
              {/*
                <button style={{background: buttonBlueColor()}} className="invite" onClick={() => this.handleOpenDialog()}>INVITE BUSINESS UNIT MEMBER</button>
                */}
              <button
                style={{ background: buttonBlueColor(), fontSize: "16px" }}
                onClick={() => this.handleCreateClientProfile()}
              >
                Create Business Unit Profile
              </button>
            </div>
            {/*for invite business unit member*/}
            <IndustryDialog
              open={this.state.open}
              roleName="administrator"
              handleCloseDialog={() => this.handleCloseDialog()}
              ifSendInvitationSuccess={this.props.ifSendInvitationSuccess}
              handleSendInvite={() => this.handleSendInvite()}
              industryOptions={this.props.industryOptions}
              tier_options={this.props.tier_options}
              account_manager={this.props.account_manager}
              send_invitation={this.props.send_invitation}
              send_invitation_error_msg={this.props.send_invitation_error_msg}
              invitation_client={this.props.invitation_client}
              client_options={
                /^(team member)/gi.test(this.props.roleName)
                  ? [
                      { value: 51, label: "Administrator" },
                      { value: 52, label: "Team Member" },
                      { value: 53, label: "Business Unit Member" },
                    ]
                  : this.props.client_options
              }
              handleInviteAnotherClient={() => this.handleInviteAnotherClient()}
              rollbackStatus={this.props.rollbackStatus}
              client_names={this.props.client_names}
              businessUnitOptions={this.props.businessUnitOptions}
              inviteBusinessMember={this.props.inviteBusinessMember}
            />
          </div>
        ) : (
          <ClientProfile
            ifCreateClientProfileSuccessBasic={
              this.props.ifCreateClientProfileSuccessBasic
            }
            clientId={this.props.clientId}
            configInsightsStandard={this.props.configInsightsStandard}
            roleInfo={this.props.roleName}
            path={this.props.match.path}
            getStates={this.props.getStates}
            allstates={this.props.allstates}
            getTimezone={this.props.getTimezone}
            timezone={this.props.timezone}
            getRoles={this.props.getRoles}
            roles={this.props.roles}
            clientProfileCancel={() => this.clientProfileCancel()}
            ifUpdateSuccess={this.props.ifUpdateSuccess}
            loginUserDetail={this.props.loginUserDetail}
            tier_options={this.props.tier_options}
            industryOptions={this.props.industryOptions}
            token={this.props.token}
            roleName="administrator"
            account_manager={this.props.account_manager}
            createClientProfile={
              isEmpty(this.props.match.params.id)
                ? this.props.createClientProfile
                : this.props.createClientBusinessUnit
            }
            createClientProfileMessage={this.props.createClientProfileMessage}
            ifCreateClientProfileSuccess={
              this.props.ifCreateClientProfileSuccess
            }
            rollbackProfileStatus={this.props.rollbackProfileStatus}
            paramId={this.props.match.params.id}
            teamMember_options={this.props.teamMember_options} // for business assign array data
          />
        )}
      </div>
    );
  }
}

export default BusinessUnits;



// WEBPACK FOOTER //
// ./src/components/Clients/EditClientProfile/BusinessUnits.jsx